import { fetchCharges } from 'actions/charges';

export default ({ dispatch }) =>
  next =>
  action => {
    const result = next(action);

    if (action.type === '@@CLIENT_INIT') {
      dispatch(fetchCharges());
    }

    return result;
  };
